"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeavyTaxation = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var HeavyTaxation = (function (_super) {
    __extends(HeavyTaxation, _super);
    function HeavyTaxation() {
        return _super.call(this, {
            cost: 3,
            tags: [Tags_1.Tags.EARTH],
            name: CardName_1.CardName.HEAVY_TAXATION,
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.EARTH, 2); }),
            metadata: {
                cardNumber: 'C14',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(2); }).nbsp.megacredits(4);
                }),
                description: 'Requires 2 Earth tags. Increase your M€ production 2 steps, and gain 4 M€.',
                victoryPoints: -1,
            },
        }) || this;
    }
    HeavyTaxation.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.megaCredits += 4;
        return undefined;
    };
    HeavyTaxation.prototype.getVictoryPoints = function () {
        return -1;
    };
    return HeavyTaxation;
}(Card_1.Card));
exports.HeavyTaxation = HeavyTaxation;
//# sourceMappingURL=HeavyTaxation.js.map